// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-tick[data-v-2f2c44b6] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.icon-tick .tick-content[data-v-2f2c44b6] {\n  border-style: solid;\n  border-top: 0;\n  border-right: 0;\n  transform: translate(35%, 16%) rotate(-45deg);\n  transform-origin: 0 100%;\n}\n", ""]);
// Exports
module.exports = exports;
